import MyAmplitude from '../providers/amplitude';
import service from './service';

export default {
  event: (args, vnode = null) => {
    const response = service.validateEvent(args, vnode);
    if (!response) return;

    if (Object.prototype.hasOwnProperty.call(response.config, 'amplitude') && response.config.amplitude) {
      (new MyAmplitude()).trackEvent(response.event, response.parameters, response.userAttributes);
    }
  },
};
